export default new Intl.DateTimeFormat('en-CA', {
  timeZoneName: 'short',
  minute: '2-digit',
  hour: '2-digit',
  day: 'numeric',
  month: 'long',
}).format;
